import { fetcherAmplify } from 'src/business/Libraries/Fetcher';
import AffidavitRepository from './AffidavitRepositoryImpl';

const affidavitRepository = new AffidavitRepository(fetcherAmplify);
export { affidavitRepository };
